import React, { Component } from "react";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import RecentMessageResultRow from "./RecentMessageResultRow";

const styles = (theme) => ({
  paper: {
    margin: "25px 0",
    padding: "10px 5px",
  },
});

class RecentMessageResult extends Component {
  render() {
    const { recentMessages, reasonVoid, classes } = this.props;
    return (
      <div style={{ width: "100%", minHeight: 300 }}>
        {recentMessages.length === 0 && (
          <Grid container spacing={8}>
            <Grid item sm>
              <Paper className={classes.paper}>
                <h3>{reasonVoid}</h3>
              </Paper>
            </Grid>
          </Grid>
        )}
        {recentMessages.length > 0 && (
          <Grid item sm>
            <Paper className={classes.paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell padding="none">Agent</TableCell>
                    <TableCell padding="none">Player</TableCell>
                    <TableCell padding="none">Is From Agent?</TableCell>
                    <TableCell padding="none">Content</TableCell>
                    <TableCell padding="none">Date Sent</TableCell>
                    <TableCell padding="none">Date Read</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {recentMessages.map((message) => (
                    <RecentMessageResultRow message={message} />
                  ))}
                </TableBody>
              </Table>
            </Paper>
          </Grid>
        )}
      </div>
    );
  }
}

RecentMessageResult.propTypes = {
  recentMessages: PropTypes.array.isRequired,
  reasonVoid: PropTypes.string.isRequired,
};

export default withStyles(styles, { withTheme: true })(RecentMessageResult);
